import { createContext } from "react";

const leadContext = createContext();

export default leadContext;
